<div class="mt-3 table-upper-bar">
	<div class="d-flex align-items-center">
		<!-- Multiselect dropdown -->
		<div *ngIf="showMultiselectDropdown" ngbDropdown>
			<custom-btn color="primary" id="dropdownBasic1" ngbDropdownToggle>
				{{ 'LABEL_ACTIONS' | translate }} <i class="bi bi-caret-down"></i>
			</custom-btn>
			<div *ngIf="showMultiselectDropdownMenu" aria-labelledby="dropdownBasic1" ngbDropdownMenu>
				<ng-container *ngFor="let action of actionset?.actions; trackBy: trackByActionId">
					<button *ngIf="action.id === ACTION_IDS.EXPORT"
							(click)="onActionEmit(action.id)"
							ngbDropdownItem>
						{{ 'ACT_EXPORT' | translate }}
					</button>
				
					<button *ngIf="action.id === ACTION_IDS.DELETE"
							(click)="onActionEmit(action.id)"
							ngbDropdownItem>
						{{ 'ACT_DELETE' | translate }}
					</button>

					<button (click)="onActionEmit(action.id)"
							*ngIf="action.id == 'ACT_OPEN'"
							ngbDropdownItem>{{
							"ACT_OPEN" |
								translate
						}}
					</button>
					<button (click)="onActionEmit(action.id)"
							*ngIf="action.id == 'ACT_CLOSE'"
							ngbDropdownItem>{{
							"ACT_CLOSE" |
								translate
						}}
					</button>

					<button (click)="onActionEmit(action.id)"
					        *ngIf="action.id == 'ACT_APPROVE'"
					        ngbDropdownItem>{{
							"ACT_APPROVE" |
								translate
						}}
					</button>
				</ng-container>
			</div>
		</div>

		<!--    ITOEM-5: added custom logic to handle notify operation-->
		<ng-container *ngIf="notificationOption != null && notificationOption.length > 0">
			<div aria-labelledby="dropdownNotificationMenu"
				 ngbDropdown>
				<custom-btn color="primary"
							id="dropdownNotification"
							ngbDropdownToggle>
					{{ 'LABEL_NOTIFY' | translate }} <i class="bi bi-caret-down"></i>
				</custom-btn>
				<div id="dropdownNotificationMenu"
					 ngbDropdownMenu>
					<ng-container *ngFor="let option of notificationOption">
						<button *ngIf="(option.notificationId | haveAction: (actionset?.actions ?? []) | async)"
								(click)="notifyRecords(option)"
								ngbDropdownItem>
							{{ option.notificationLabel | translate }}
						</button>
					</ng-container>
				</div>
			</div>
		</ng-container>

		<!--    ITOEM-05: added custom logic to handle manual action operation-->
		<ng-container *ngIf="manualOption != null && manualOption.length > 0">
			<div aria-labelledby="dropdownNotificationMenu"
				 ngbDropdown>
				<custom-btn color="primary"
							id="dropdownManualOption"
							ngbDropdownToggle>
					{{ 'LABEL_MANUAL_OPTION' | translate }} <i class="bi bi-caret-down"></i>
				</custom-btn>
				<div id="dropdownManualOptionMenu"
					 ngbDropdownMenu>
					<ng-container *ngFor="let option of manualOption">
						<button *ngIf="(option.manualActionId | haveAction: (actionset?.actions ?? []) | async)"
								(click)="onActionEmit(option.manualActionId + '_MANUAL_ACTION')"
								ngbDropdownItem>
							{{ option.manualActionName | translate }}
						</button>
					</ng-container>
				</div>
			</div>
		</ng-container>

		<!-- Custom toolbar actions-->
		<app-custom-toolbar-actions
			[actions]="actionset?.actions ?? []"
			(action)="onActionEmit($event)"
			[detailId]="detailId">
		</app-custom-toolbar-actions>

		<!-- Icon buttons for export/import/convert -->
		<ng-container *ngFor="let action of actionset?.actions; trackBy: trackByActionId">
			<!--
			<custom-btn *ngIf="action.id === ACTION_IDS.EXPORT"
						(click)="onActionEmit(action.id + '_ALL')"
						[iconButton]="true"
						[iconClasses]="'insert_drive_file'"
						[iconColor]="'green'"
						matTooltip="{{ 'LABEL_EXPORT' | translate }}">
			</custom-btn>
			<custom-btn *ngIf="action.id === ACTION_IDS.IMPORT"
						(click)="onActionEmit(action.id + '_ALL')"
						[iconButton]="true"
						[iconClasses]="action.icon"
						[iconColor]="'green'"
						matTooltip="{{ 'LABEL_IMPORT' | translate }}">
			</custom-btn>
			-->
		</ng-container>


	</div>


	<span *ngIf="!showMultiselectDropdown && !actionset?.actions?.length" class="spacer"></span>



	<div class="d-flex">
		<!-- Sorting buttons -->
		<custom-btn *ngIf="length > 0"
					(click)="onClearSort()"
					class="clear-sort-btn" color="primary">
			{{ 'ACT_CLEAR_SORT' | translate }}
		</custom-btn>

		<custom-btn *ngIf="length > 0"
					(click)="onResetSort()"
					class="reset-sort-btn" color="primary">
			{{ 'ACT_RESET_SORT' | translate }}
		</custom-btn>

		<!-- Paginator -->
		<lc-custom-table-paginator *ngIf="length > 0"
							(onPaginatorChange)="onPageChange($event)"
							[numElementsLoaded]="numElementsLoaded"
							[numElementsSize]="length"
							[page]="pageEvent.pageIndex"
							[paginatorLoaderList]="[50, 100, 250]"
							[paginatorLoaderTitle]="'LABEL_TABLE_PAGINATOR' | translate"
							[paginatorLoader]="50"
							class="right">
		</lc-custom-table-paginator>
		<!-- Add button -->
		<ng-container *ngFor="let action of actionset?.actions; trackBy: trackByActionId">
			<div *ngIf="action.id === ACTION_IDS.ADD">
				<custom-btn (click)="onAddClick()"
							[disabled]="isActionDisabled(action.id)"
							class="t3" color="primary">
					{{ 'ACT_ADD' | translate }}
				</custom-btn>
			</div>
		</ng-container>

		

		<!-- Settings button -->
		<div *ngIf="showColumnSettings" class="d-flex align-items-center">
			<mat-icon (click)="onOpenSettings($event)"
					  matTooltip="{{ 'LABEL_COLUMN_SETTINGS' | translate }}"
					  style="float: right; margin-right: 1rem; cursor: pointer;">
				settings
			</mat-icon>
		</div>
	</div>
</div>
